// extracted by mini-css-extract-plugin
export default {"form":"Donate_form__fROPG"};